/**
 * Build a single URL path segment for a planner keyword.
 * History/API may already return percent-encoded values; decode once then
 * encode once so React Router does not get `%2520` (double-encoded spaces).
 */
export function toUrlKeywordSegment(
  keyword: string | null | undefined
): string {
  const raw = String(keyword ?? '');
  if (!raw) return '';

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw.replace(/\+/g, '%20'));
  } catch {
    decoded = raw;
  }

  return encodeURIComponent(decoded);
}
